import { ValidationMethod } from '@/helpers/validation/Validator';
import moment from 'moment';
import i18n from '@/localization/localization';

const date: ValidationMethod = (input, key = '') => {
    const check = moment.isMoment(input) || Object.prototype.toString.call(input) === '[object Date]';

    return {
        success: check,
        message: !check ? i18n.t('validation.validation_date', { key }).toString() : undefined,
    };
};

export default date;
